module.exports = __webpack_public_path__ + "static/img/a3.22585db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a3.png
// module id = N+Rt
// module chunks = 0